import {
  fetch as dataFetch,
  fetchAuth,
  normalize,
  UnauthorizedError,
} from "./dataAccess";

export { normalize, UnauthorizedError };

export function apiPath(path) {
  const trimmed = path.startsWith("/") ? path.slice(1) : path;
  return trimmed.startsWith("api/") ? trimmed : `api/${trimmed}`;
}

export function apiFetch(path, options = {}) {
  return dataFetch(apiPath(path), options);
}

export function apiFetchAuth(path, options = {}) {
  return fetchAuth(apiPath(path), options);
}

export function apiPost(path, body, options = {}) {
  return apiFetch(path, {
    method: "POST",
    body: JSON.stringify(body),
    ...options,
  });
}

export function apiPostAuth(path, body, options = {}) {
  return apiFetchAuth(path, {
    method: "POST",
    body: JSON.stringify(body),
    ...options,
  });
}

export function parseJson(response) {
  return response.json().then((retrieved) => ({ retrieved }));
}
